<template>
  <DrawerVue :refreshDisplay="refreshDisplay">
    <v-container fluid class="mt-4">
      <v-row class="mb-4" align="center">
        <v-col cols="auto">
          <h2 v-if="retreatData">
            {{ $t("basics.edit", { type: $t("basics.retreat") }) }}
          </h2>
          <h2 v-else>
            {{ $t("basics.new", { type: $t("basics.retreat") }) }}
          </h2>
        </v-col>

        <v-spacer />

        <v-col cols="auto" v-if="retreatData && $checkFunctionPermission(['retreat_delete_detail'])">
          <v-tooltip :text="$t('basics.delete')">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" @click="showDeleteRetreat()" class="icon-transparency hoverable">
                mdi-trash-can
              </v-icon>
            </template>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-form ref="retreatEditForm">
        <v-row>
          <v-col cols="12">
            <v-text-field variant="outlined" flat :rules="[requiredRule, max256]" v-model="name"
              :label="$t('basics.name') + '*'" :readonly="readonly"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-select :disabled="retreatData != undefined" variant="outlined" flat :items="availTypes"
              :rules="[requiredRule]" v-model="type" :label="$t('basics.type') + '*'"
              @update:model-value="selectPresets" returnObject item-title="name" item-value="name"
              :readonly="readonly"></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-textarea variant="outlined" flat :rules="[max5000]" v-model="description"
              :label="$t('basics.description')" :readonly="readonly"></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field variant="outlined" flat type="number" step="0.01" :rules="[requiredRule]" v-model="price"
              :label="$t('basics.price') + '*'" :readonly="readonly" @blur="validatePrice"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field v-model="startDate" :label="$t('basics.startDate') + '*'" variant="outlined" type="date"
              placeholder="DD.MM.YYYY" :rules="[requiredRule, startDateSmallerRule]"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field v-model="endDate" :label="$t('basics.endDate') + '*'" variant="outlined" type="date"
              placeholder="DD.MM.YYYY" :rules="[requiredRule, startDateSmallerRule]"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-select variant="outlined" flat :items="availStatuses" :rules="[requiredRule]" v-model="status"
              :label="$t('basics.status') + '*'" returnObject
              :item-title="(item) => $t('constants.product_status_' + item.name)" item-value="name"
              :readonly="readonly"></v-select>
          </v-col>
        </v-row>

        <v-row v-if="!readonly">
          <v-col cols="12">
            <v-btn large block flat class="primaryButton" @click="confirm()" ref="confirmButton" style="width: 100%">
              <span>{{ $t("basics.confirm") }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </DrawerVue>
</template>

<script>
export default {
  name: "retreatEditDrawer",
  props: ["retreatData", "refreshDisplay", "readonly"],
  emits: ["close", "delete"],

  data() {
    return {
      name: undefined,
      description: undefined,
      price: undefined,
      status: undefined,
      type: undefined,

      availStatuses: [],
      availPaymentMethods: [],
      availTypes: [],

      startDate: undefined,
      startDatePicker: false,

      endDate: undefined,
      endDatePicker: false,


      requiredRule: (value) =>
        value !== null && value !== undefined && value !== '' ||
        this.$i18n.t("messages.required"),
      max256: (value) =>
        !value || value.length <= 256 || this.$i18n.t("messages.tooLong", { count: 256 }),
      max5: (value) =>
        !value || value.length <= 5 || this.$i18n.t("messages.tooLong", { count: 5 }),
      max5000: (value) =>
        !value ||
        value.length <= 5000 ||
        this.$i18n.t("messages.tooLong", { count: 5000 }),

      startDateSmallerRule: (value) =>
        !this.startDate ||
        !this.endDate ||
        this.startDate <= this.endDate ||
        typeof value == "object" ||
        this.$i18n.t("messages.startDateTooBig"),
    };
  },

  components: {
  },

  watch: {
    refreshDisplay() {
      this.fetchStatuses().then(() => {
        this.fetchTypes().then(() => {
          this.setValues();
        })
      })
    },
  },

  methods: {
    validatePrice(val) {
      if (this.price > 99999) {
        this.price = 99999
      }
    },
    showDeleteRetreat() {
      this.$emit("delete")
    },
    selectPresets(type) {
      if (type) {
        if (type.default_price !== undefined) {
          this.price = type.default_price
        }
      }
    },
    async fetchStatuses() {
      return new Promise((resolve, reject) => {
        this.axios.get(this.axios.defaults.baseURL + "media/productstatuses/")
          .then((resp) => {
            this.availStatuses = resp.data

            resolve()
          })
          .catch((e) => {
            reject()
            console.log(e);
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          });
      })
    },
    async fetchTypes() {
      return new Promise((resolve, reject) => {
        this.axios.get(this.axios.defaults.baseURL + "media/producttypes/?size=10000")
          .then((resp) => {
            this.availTypes = resp.data.results

            resolve()
          })
          .catch((e) => {
            reject()
            console.log(e);
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          });
      })
    },
    async confirm() {
      const { valid } = await this.$refs.retreatEditForm.validate();

      if (valid) {
        let formData = {
          name: this.name,
          description: this.description,
          price: this.price !== undefined && this.price !== null
            ? parseFloat(this.price)
            : null,
          type: this.type.id,
          start_date: this.$moment(this.startDate).format("YYYY-MM-DD"),
          end_date: this.$moment(this.endDate).format("YYYY-MM-DD"),
        };

        if (this.status !== undefined) {
          formData.status = this.status.key
        }

        if (this.retreatData) {
          formData.id = this.retreatData.id;
          this.patchData(formData);
        } else {
          this.postData(formData);
        }
      }
    },
    postData(formData) {
      this.axios
        .post(this.axios.defaults.baseURL + "media/retreats/post/", formData)
        .then((resp) => {
          this.$emit("close", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },

    patchData(formData) {
      this.axios
        .patch(
          this.axios.defaults.baseURL + "media/retreats/patch/" + formData.id,
          formData
        )
        .then((resp) => {
          this.$emit("close", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    setValues() {
      if (this.retreatData) {
        this.name = this.retreatData.name;
        this.description = this.retreatData.description;
        this.price = this.retreatData.price;
        this.type = this.retreatData.type

        this.startDate = this.retreatData.start_date;
        this.endDate = this.retreatData.end_date;

        if (this.retreatData.status !== undefined) {
          for (let i = 0; i < this.availStatuses.length; i++) {
            if (this.retreatData.status == this.availStatuses[i].key) {
              this.status = this.availStatuses[i]
            }
          }
        }
        else {
          this.status = undefined;
        }
      } else {
        this.name = undefined;
        this.description = undefined;
        this.price = undefined;
        this.type = undefined

        this.status = undefined;

        this.startDate = undefined
        this.endDate = undefined

      }
    },
  },

  mounted() { },
};
</script>
